import { useEffect } from 'react';

/**
 * Flags an active sidebar drag on <html> (`sidebar-resizing`). The main
 * content's margin-left is injected by App.js with a 0.2s transition (nice on
 * open/close) — but during a drag the sidebar itself moves untransitioned, so
 * the animated content lags behind and bares the app background. The class
 * lets App.scss kill the content transition only while dragging.
 */
export default function useSidebarResizing(isResizing) {
    useEffect(() => {
        if (!isResizing) return undefined;
        document.documentElement.classList.add('sidebar-resizing');
        return () => document.documentElement.classList.remove('sidebar-resizing');
    }, [isResizing]);
}
